import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { getCredits } from '../api/credits';
import CreditCard from '../components/credit/creditCard'
import { Spinner } from 'reactstrap';
import mixpanel from 'mixpanel-browser';
import { bankpay_consumer_user_id } from '../common/constants';
import { getLocalStorageData } from '../common/resubale-functions';

const Credits = () => {
  const history = useHistory();
  const [credits, setCredits] = useState([]);  
  const [totalRow, setTotalRow] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  var event_sent = false

  const goToPage = (credit) => {
    mixpanel.track("Clicked Credit Card", {
        distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
        merchant_id: credit.merchant_unique_id,
        store_name: credit.store_name,
        touch_point: "consumer web",
      },
      {send_immediately: true}
    );
    history.push(`/credits?merchant=${credit.merchant_unique_id}`)
  };
  
  useEffect(() => {
    getAllCredits();
  },[currentPage]);

  useEffect(() => {
    document.title = 'Credits';
  },[])

  const getAllCredits = async () => {
    const res = await getCredits(currentPage);
    setCredits(res?.data.data?.results);
    if(currentPage >= 2){
        setCredits([...credits,...res?.data.data?.results]);        
    }
    setTotalRow(res?.data.data?.count)
    if (!event_sent) {
      console.log(getLocalStorageData(bankpay_consumer_user_id, 'string'))
      mixpanel.track("Viewed Credits Home", {
          distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
          touch_point: "consumer web",
          total_credit_balance: res?.data.data?.results.reduce((acc,curr) => (curr.total_credit_amount/100)+acc, 0),
        },
        {send_immediately: true}
      );
      event_sent = true
    }
  };

  const loadNextPage = ()=>{
    setCurrentPage(currentPage + 1);
  }

  return (    
    <div className="credits-page max-w-[710px] mx-auto pt-5 flex flex-col lg:h-full">
        <div className="page-title mb-2 lg:mb-6 text-[32px] font-Rany font-bold grow-0 shrink-0">
            Your credits
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {credits.map((item) => (
            <CreditCard onButtonClick={() => goToPage(item)} key={item.merchant_unique_id}  credit={item} /> 
        ))}
        </div>
        <div className="shrink-0 text-center pt-6 grow-0">        
            {credits.length < totalRow &&
                <div onClick={() => loadNextPage()}
                    className="bg-[#E9ECEF] py-1 px-3 cursor-pointer inline-flex gap-2 items-center rounded-lg hover:bg-[#6C757D] hover:text-white">
                    See more 
                    <svg className="h-2 w-4" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.57104 9.32874L15.7638 1.86136C16.0787 1.53369 16.0787 1.00283 15.7638 0.674336C15.4489 0.346673 14.9374 0.346673 14.6225 0.674336L8.0004 7.54941L1.37835 0.675163C1.06342 0.3475 0.551909 0.3475 0.236191 0.675163C-0.0787316 1.00283 -0.0787316 1.53452 0.236191 1.86219L7.42896 9.32956C7.74062 9.65226 8.26017 9.65226 8.57104 9.32874Z" fill="currentColor"/>
                    </svg>
                </div>
            }            
        </div>
    </div>        
  );
};

export default Credits;
